<template>Redirecting...</template>

<script setup lang="ts">
const route = useRoute();
const router = useRouter();

router.push(JSON.parse(route.query.to));
</script>
